import React from "react";
import { Grid } from "@mui/material";
import { useQuery } from "react-query";
import { getVehicleModelsList } from "../../../services/vehicle";
import InfoTile from "../../common/InfoTile";

/**
 * Stat tile showing total vehicle model count.
 * Mirrors VehicleGroupsStats in structure.
 */
const VehicleModelsStats = () => {
  const { data } = useQuery(
    ["vehicleModelsStats", 1, 1, "createdAt", "desc", {}, []],
    getVehicleModelsList,
    {
      refetchOnWindowFocus: false,
      useErrorBoundary: false,
      suspense: true,
    }
  );

  const total =
    data?.data?.meta?.itemCount ??
    data?.data?.meta?.total ??
    data?.meta?.itemCount ??
    data?.meta?.total ??
    "—";

  return (
    <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }} >
      <InfoTile title={"Total Vehicle Models"} info={total} />
    </Grid>
  );
};

export default VehicleModelsStats;